<!-- eslint-disable max-len -->
<template>
  <div
    class="docs-view"
  >
    <div
      v-if="clientPortalStore.hasRequestedDocuments"
      class="docs-side"
    >
      <Stack gap="2">
        <Stack
          v-for="section in clientPortalStore.checklistSectionsExcludingOther"
          :key="section.key"
          gap="1"
        >
          <MenuLabel class="section-title">
            {{ section.name }} Documents
          </MenuLabel>

          <!-- Individual Documents in Section -->
          <Menu>
            <MenuList>
              <DocumentPortalItem
                v-for="document in section.documents"
                :key="`${section.key}-${document.sequentialNumber}`"
                :document="document"
                :section="section"
              />
            </MenuList>
          </Menu>
        </Stack>

        <MenuDivider />

        <MenuItem
          :active="clientPortalStore.currentStep === 'others'"
          :count="clientPortalStore.otherDocuments.length"
          @click="clientPortalStore.setCurrentStep('others')"
        >
          Other Documents
        </MenuItem>
      </Stack>
    </div>

    <main
      id="document-portal-main"
      class="docs-main"
    >
      <DocumentPortalOthers
        v-if="showOthers"
      />

      <DocumentPortalUpload v-else />
    </main>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useClientPortalStore } from '@frontend/ui/stores/clientPortalStore';
import DocumentPortalUpload from '@frontend/ui/features/example/components/DocumentPortalUpload.vue';
import DocumentPortalItem from './DocumentPortalItem.vue';
import DocumentPortalOthers from './DocumentPortalOthers.vue';
import { Menu, MenuLabel, MenuList, MenuItem, MenuDivider, Stack } from '@stakeui';

// Define props
const props = defineProps({
  entityExternalId: {
    type: String,
    default: '',
  },
  firmSlug: {
    type: String,
    required: false,
    default: '',
  },
  advisorSlug: {
    type: String,
    required: false,
    default: '',
  },
  portalType: {
    type: String,
    required: false,
    default: 'client', // 'firm', 'advisor', or 'client'
  },
  previewMode: {
    type: Boolean,
    default: false,
  },
  advisorView: {
    type: Boolean,
    default: false,
  },
});

const clientPortalStore = useClientPortalStore();

// With no requested document, "Other" is the only upload target, so it becomes
// the whole view instead of a step the client has to navigate to.
const showOthers = computed(
    () => !clientPortalStore.hasRequestedDocuments ||
      clientPortalStore.currentStep === 'others',
);

onMounted(async () => {
  await clientPortalStore.initializePortal({
    entityExternalId: props.entityExternalId,
    advisorSlug: props.advisorSlug,
    firmSlug: props.firmSlug,
    advisorView: props.advisorView,
  });
});
</script>

<style scoped>
.docs-view {
  display: flex;
  gap: 2em;
}

.docs-side {
  width: 16em;
  flex-shrink: 0;
  flex-grow: 0;
}

.docs-main {
  width: 100%;
}
</style>
